module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjAiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAyMCAxNSI+PGRlZnM+PHBhdGggaWQ9IjdpY25hIiBkPSJNNDEuMjUgMTU0LjdsLTMuNzUgMy4wOC01LjYzLTUuNTUtNC4zNyA1LjU1djUuNTRoMTYuMjV6bTMuNzUgOS44NUgyNi4yNVYxNTFIMjV2MTQuNzhoMjB6Ii8+PC9kZWZzPjxnPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yNSAtMTUxKSI+PHVzZSBmaWxsPSIjYzBmNGZmIiB4bGluazpocmVmPSIjN2ljbmEiLz48L2c+PC9nPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./components/atoms/Icon/icons/dashboard.svg
// module id = 1724
// module chunks = 0